import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import { Card, Button } from "react-bootstrap";

import PermissionTable from "./components/PermissionTable";
import { getPermissions, clearPermissions } from "./actions";
import ProtectedPage from "~/components/security/ProtectedPage";

import { ROLE_ADMIN, ROLE_ORG_ADMIN } from "~/utils/constants/roles";

const Permissions = ({ t }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { permissions } = useSelector((state) => state.permissionReducer);

  useEffect(() => {
    dispatch(getPermissions());
    return () => {
      dispatch(clearPermissions());
    };
  }, [dispatch]);

  const persistPermission = () => {
    history.push("/uniksystem/admin/permission/create");
  };

  return (
    <ProtectedPage roles={[ROLE_ADMIN, ROLE_ORG_ADMIN]}>
      <div className="main-card-v2">
        <Card bsPrefix="card-flat">
          <Card.Header className="justify-content-between">
            <h6>{t("admin.permission.list.cardTitle")}</h6>
          </Card.Header>

          <Card.Body>
            <PermissionTable
              permissions={permissions}
              persistPermission={persistPermission}
            />
          </Card.Body>
        </Card>
      </div>
    </ProtectedPage>
  );
};

export default withNamespaces()(Permissions);
